import React, { useState } from "react";
import { GraphCanvas } from "reagraph";
import Modal from "react-bootstrap/Modal";
import Image from "react-bootstrap/Image";
import Table from "react-bootstrap/Table";
import { setSelectionRange } from "@testing-library/user-event/dist/utils";

export default function MyGraph(props) {
  const [show, setShow] = useState(false);
  const [nodeInfo, setNodeInfo] = useState("");
  const [companyData, setCompanyData] = useState([]);

  const handleClose = () => setShow(false);
  const linkedBusinessDict = props.listCompany;
  const linkedPeopleDict = props.listPeople;

  const nodes = props.nodes;

  const handleShowLB = (label) => {
    const selectedCompany = linkedBusinessDict.find(
      (item) => item.businessName === label
    );

    if (selectedCompany) {
      const list = [
        { key: "Nome Attività", value: selectedCompany.businessName },
        { key: "Indirizzo", value: selectedCompany.address },
        {
          key: "Capitale Dichiarato",
          value: selectedCompany.shareCapital.toLocaleString("it-IT", {
            style: "currency",
            currency: "EUR",
          }),
        },
        //id attività e id azienda fuori
        { key: "Numero Azienda", value: selectedCompany.companyNumber },
        {
          key: "Numero Registrazione Attività",
          value: selectedCompany.companyRegistrationNumber,
        },
        { key: "Paese", value: selectedCompany.country },
        { key: "Indirizzo Email", value: selectedCompany.emailAddresses },
        { key: "Eventi Cigs", value: selectedCompany.hasCigsEvents },
        {
          key: "Insolvenze Aziendali",
          value: selectedCompany.hasCompaniesInsolvency,
        },
        { key: "Insolvenze", value: selectedCompany.hasInsolvency },
        { key: "Pregiudizi", value: selectedCompany.hasPrejudicials },
        {
          key: "Pregiudizi Gravi",
          value: selectedCompany.hasSeverePrejudicials,
        },
        { key: "Proteste", value: selectedCompany.hasProtesti },
        { key: "Proteste Gravi", value: selectedCompany.hasSevereProtesti },
        { key: "HQType", value: selectedCompany.hqType },
        //incorporation data fuori
        {
          key: "Data dell'ultimo Rating effettuato",
          value: selectedCompany.latestRatingChangeDate,
        },
        // {
        //   key: "LatestShareholdersEquityFigure",
        //   value: selectedCompany.latestShareholdersEquityFigure,
        // },
        // {
        //   key: "LatestTurnoverFigure",
        //   value: selectedCompany.latestTurnoverFigure,
        // },
        // { key: "LatestUpdateOnIc", value: selectedCompany.latestUpdateOnIc },
        { key: "Forma Legale", value: selectedCompany.legalForm },
        { key: "Tipo Forma Legale", value: selectedCompany.legalFormType },
        {
          key: "Classificazione Attività Principale",
          value: selectedCompany.mainActivityClassification,
        },
        {
          key: "Codice Attività Principale",
          value: selectedCompany.mainActivityCode,
        },
        {
          key: "Descrizione Attività Principale",
          value: selectedCompany.mainActivityDescription,
        },
        { key: "Numero Dipendenti", value: selectedCompany.numberOfEmployees },
        { key: "Provincia", value: selectedCompany.province },
        {
          key: "Sezione Registro Pubblico",
          value: selectedCompany.publicRegisterSection,
        },
        { key: "Codice Rae", value: selectedCompany.raeCode },
        {
          key: "Iscrizione Rae",
          value: selectedCompany.reaInscriptionDate,
        },
        { key: "Stato Registrazione", value: selectedCompany.registerStatus },
        { key: "Codice Sae", value: selectedCompany.saeCode },
        { key: "Stato", value: selectedCompany.status },
        { key: "Stato Descrizione", value: selectedCompany.statusDescription },
        { key: "Codice Tax", value: selectedCompany.taxCode },
        { key: "Telephone", value: selectedCompany.telephone },
        {
          key: "Numero Registrazione Vat",
          value: selectedCompany.vatRegistrationNumber,
        },
      ];

      setCompanyData(list);
    }
  };

  const handleshowLP = (idP) => {
    const selectedPerson = linkedPeopleDict.find(
      (item) => item.personId === idP
    );

    if (selectedPerson) {
      const list = [
        { key: "Nome", value: selectedPerson.forename },
        { key: "Cognome", value: selectedPerson.surname },
        { key: "Sesso", value: selectedPerson.gender },
        { key: "Nazionalità", value: selectedPerson.nationality },
        { key: "Notizie Negative", value: selectedPerson.isAdverseMedia },
        { key: "Deceduto", value: selectedPerson.isDeceased },
        {
          key: "Squalificato dal Ruolo",
          value: selectedPerson.isDisqualifiedDirector,
        },
        {
          key: "Regolatore Finanziario",
          value: selectedPerson.isFinancialregulatorv,
        },
        { key: "Insolvente", value: selectedPerson.isInsolvent },
        {
          key: "Associato a Forze dell'Ordine",
          value: selectedPerson.isLawEnforcement,
        },
        { key: "PEP", value: selectedPerson.isPEP },
        {
          key: "Attualmente Sanzionato",
          value: selectedPerson.isSanctionsCurrent,
        },
        {
          key: "Precedentemente Sanzionato",
          value: selectedPerson.isSanctionsPrevious,
        },
        {
          key: "Numero Cellulare",
          value: selectedPerson.mobileNumber,
        },

        {
          key: "Numero Fisso",
          value: selectedPerson.telephoneNumber,
        },
        { key: "Indirizzo Email", value: selectedPerson.email },
        { key: "Numero Fax", value: selectedPerson.faxNumber },
        {
          key: "imageURL",
          value: selectedPerson.imageURL,
        },
      ];
      setCompanyData(list);
    }
  };

  const handleClickNode = (nodeId) => {
    setCompanyData([]);
    if (
      nodeId.label !== "Link People" &&
      nodeId.label !== "Link Business" &&
      nodeId.id !== "0"
    ) {
      if (nodeId.id > 7) {
        handleShowLB(nodeId.label);

        setNodeInfo(nodeId);
        setShow(true);
      }
      if (nodeId.id <= 7) {
        handleshowLP(nodeId.data.idP);

        setNodeInfo(nodeId);
        setShow(true);
      }
    }
    // Esegui le azioni desiderate quando viene cliccato un nodo
  };

  const edges = [
    {
      source: "0",
      target: "1",
      id: "0-1",
      size: 5,
    },
    {
      source: "0",
      target: "2",
      id: "0-2",
      size: 5,
    },
    {
      source: "1",
      target: "3",
      id: "0-3",
    },
    {
      source: "1",
      target: "4",
      id: "0-4",
    },
    {
      source: "1",
      target: "5",
      id: "0-5",
    },
    {
      source: "1",
      target: "6",
      id: "0-6",
    },
    {
      source: "1",
      target: "7",
      id: "0-7",
    },
    {
      source: "2",
      target: "8",
      id: "0-8",
    },
    {
      source: "2",
      target: "9",
      id: "0-9",
    },
    {
      source: "2",
      target: "10",
      id: "0-10",
    },
    {
      source: "2",
      target: "11",
      id: "0-11",
    },
    {
      source: "2",
      target: "12",
      id: "0-12",
    },
  ];

  return (
    <>
      <GraphCanvas
        sizingType="centrality"
        //layoutType="hierarchicalTd"
        layoutType="treeLr2d"
        //layoutType="hierarchicalLr"
        nodes={nodes}
        // nodes={nodes.map((node) => ({
        //   ...node,
        //   icon: (
        //     <img
        //       className="round-image" // Aggiungi la classe CSS "round-image"
        //       src={node.icon}
        //       alt={node.label}
        //     />
        //   ),
        // }))}
        edges={edges}
        labelType="all"
        onNodeClick={handleClickNode}
      />

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Modal title</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {companyData.find((item) => item.key === "imageURL")?.value !== "" ? (
            <Image
              style={{ width: "35%" }}
              src={companyData.find((item) => item.key === "imageURL")?.value}
            />
          ) : (
            "Immagine non disponibile"
          )}

          {companyData.map((item, index) => (
            <Table responsive striped bordered hover key={index}>
              <thead>
                <tr>
                  <th>{item.key}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {item.value === false
                      ? "false"
                      : item.value === true
                      ? "true"
                      : item.value}
                  </td>
                </tr>
              </tbody>
            </Table>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <button variant="secondary" onClick={handleClose}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
